module.exports = __webpack_public_path__ + "static/img/cover.1e6ac14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/cover.jpg
// module id = 9hsP
// module chunks = 0